import React from 'react';
import { CountdownTimer } from '../components/CountdownTimer';
import { PricingSelector } from '../components/PricingSelector';
const comparisonTable = [{
  sit: 'Te duele el cuello al final del día',
  sin: 'Tomás ibuprofeno y seguís igual',
  con: 'La Ingeniería de Postura elimina el dolor en 72 horas ajustando la altura de la camilla'
}, {
  sit: 'Tardás 2 horas en cada set',
  sin: 'Atendés 4 clientas por día con agotamiento total',
  con: 'El Método de Compresión bajás a 1:15hs y podés atender 6 sin más cansancio'
}, {
  sit: 'Los vapores del adhesivo te molestan',
  sin: 'Seguís expuesta sin sistema de protección',
  con: 'El Protocolo de Blindaje Químico protege tus pulmones y tu carrera a largo plazo'
}, {
  sit: 'Tus ojos están rojos al final de la jornada',
  sin: 'Fatiga visual acumulada día tras día',
  con: 'El Sistema de Protección Visual elimina el enrojecimiento y previene daño progresivo'
}, {
  sit: 'No sabés si vas a poder trabajar 10 años más',
  sin: 'Miedo real a que el cuerpo te obligue a parar',
  con: 'La Rutina Recuperadora de 5 minutos extiende tu carrera profesional 15 años'
}, {
  sit: 'Tus muñecas se entumecen',
  sin: 'Riesgo real de Túnel Carpiano',
  con: 'El Protocolo de Estiramientos Pro previene la lesión más común de la profesión'
}];
const eliteFeatures = ['Módulo 1: Ingeniería de Postura — el sistema de los 90 grados', 'Módulo 2: Compresión de Tiempos — bajá 45 minutos por set', 'Módulo 3: Blindaje Químico y Visual', 'Módulo 4: El Protocolo Recuperador de 5 minutos', 'Checklist de Estación de Trabajo Ergonómica', 'Guía de Estiramientos Pro para pegar en tu cabina', 'Cronómetro de Tiempos para detectar fugas', 'Lista de Compras Inteligente de equipamiento'];
export function PricingSection() {
  return <section id="pricing" className="py-12 md:py-24 bg-[#F4EDE4]" data-id="element-110">
      <div className="max-w-6xl mx-auto px-4" data-id="element-111">
        {/* Urgency */}
        <div className="max-w-2xl mx-auto text-center mb-8 md:mb-16" data-id="element-112">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full bg-[#5A2A3D]/10 text-[#5A2A3D] font-bold text-[10px] sm:text-xs uppercase tracking-[0.2em] mb-6 sm:mb-8 border border-[#5A2A3D]/20" data-id="element-113">
            <span className="w-1.5 h-1.5 rounded-full bg-[#5A2A3D] animate-pulse" data-id="element-114" />
            Precio de lanzamiento — Cierra en:
          </div>

          <CountdownTimer data-id="element-115" />

          <p className="text-sm sm:text-base md:text-lg text-[#5A4A4F] mt-6 sm:mt-8 mb-4 sm:mb-6 italic" data-id="element-116">
            ⚠️ Después sube $8.000 ARS. No vuelve.
          </p>

          <div className="max-w-md mx-auto bg-white border border-[#E8D5C4] rounded-xl p-3 sm:p-4 shadow-sm" data-id="element-117">
            <div className="text-[10px] sm:text-xs font-bold text-[#5A2A3D] flex items-center gap-2 mb-2 uppercase tracking-wider" data-id="element-118">
              <span className="w-1.5 h-1.5 rounded-full bg-[#5A2A3D] animate-pulse" data-id="element-119" />
              Cupos al precio de lanzamiento — Quedan pocos
            </div>
            <div className="w-full bg-[#FAF6F0] rounded-full h-2.5 sm:h-3 overflow-hidden mb-1 border border-[#E8D5C4]" data-id="element-120">
              <div className="bg-gradient-to-r from-[#5A2A3D] to-[#B8956A] h-full rounded-full" style={{
              width: '68%'
            }} data-id="element-121" />
            </div>
            <div className="text-[10px] sm:text-xs text-[#B8956A] text-right font-medium" data-id="element-122">
              68% ya tomados
            </div>
          </div>
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-6xl text-[#2D1A22] text-center mb-8 md:mb-12 leading-tight" data-id="element-123">
          Elegí tu <span className="italic" data-id="element-124">Kit</span>
        </h2>

        {/* Compact unified pricing selector */}
        <PricingSelector data-id="element-125" />

        {/* Elite Comparison */}
        <div className="max-w-5xl mx-auto mt-16 md:mt-24" data-id="element-126">
          <h3 className="text-2xl sm:text-3xl md:text-5xl text-[#2D1A22] text-center mb-8 md:mb-12 leading-tight" data-id="element-127">
            ¿Qué agrega{' '}
            <span className="italic text-[#5A2A3D]" data-id="element-128">Lashista de Élite</span>?
          </h3>

          <div className="bg-white border border-[#E8D5C4] rounded-2xl md:rounded-3xl overflow-hidden mb-8 md:mb-12 shadow-md" data-id="element-129">
            <div className="overflow-x-auto" data-id="element-130">
              <table className="w-full text-left min-w-[600px]" data-id="element-131">
                <thead data-id="element-132">
                  <tr className="bg-[#FAF6F0]" data-id="element-133">
                    <th className="p-3 sm:p-4 md:p-6 text-[#2D1A22] font-bold text-[10px] sm:text-xs uppercase tracking-wider border-b border-[#E8D5C4] w-1/3" data-id="element-134">
                      Tu situación
                    </th>
                    <th className="p-3 sm:p-4 md:p-6 text-[#5A2A3D] font-bold text-[10px] sm:text-xs uppercase tracking-wider border-b border-[#E8D5C4] w-1/3" data-id="element-135">
                      ❌ Sin Élite
                    </th>
                    <th className="p-3 sm:p-4 md:p-6 text-[#B8956A] font-bold text-[10px] sm:text-xs uppercase tracking-wider border-b border-[#E8D5C4] w-1/3" data-id="element-136">
                      ✓ Con Élite
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-137">
                  {comparisonTable.map((row, i) => <tr key={i} className="border-b border-[#E8D5C4] hover:bg-[#FAF6F0]/50 transition-colors" data-id="element-138">
                      <td className="p-3 sm:p-4 md:p-6 text-[#2D1A22] font-medium text-xs sm:text-sm" data-id="element-139">
                        {row.sit}
                      </td>
                      <td className="p-3 sm:p-4 md:p-6 text-[#5A4A4F] text-xs sm:text-sm" data-id="element-140">
                        {row.sin}
                      </td>
                      <td className="p-3 sm:p-4 md:p-6 text-[#5A2A3D] font-medium text-xs sm:text-sm" data-id="element-141">
                        {row.con}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-white border border-[#E8D5C4] rounded-2xl md:rounded-3xl p-5 sm:p-6 md:p-10" data-id="element-142">
            <h4 className="text-xl sm:text-2xl md:text-3xl text-[#2D1A22] mb-5 sm:mb-8 text-center" data-id="element-143">
              <span className="italic" data-id="element-144">Lashista de Élite</span> incluye:
            </h4>
            <div className="grid sm:grid-cols-2 gap-2.5 sm:gap-3 md:gap-4" data-id="element-145">
              {eliteFeatures.map((f, i) => <div key={i} className="flex items-start gap-2 sm:gap-3" data-id="element-146">
                  <span className="text-[#B8956A] mt-0.5 shrink-0" data-id="element-147">✓</span>
                  <span className="text-[#5A4A4F] font-medium text-xs sm:text-sm md:text-base" data-id="element-148">
                    {f}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}